module.exports = __webpack_public_path__ + "6be892a12996afa17740cf431ed66799.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/home-slide-1.jpg
// module id = 264
// module chunks = 0